export enum ThemeEnum {
  Dark = "dark",
  Light = "light",
}
